import Component from './Question';

export default Component;
